<template>
  <div>
    <user-token-site-info :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <div class="data-table-title">
      <div class="data-table-description">
        インフルエンサーの登録リクエスト・データインポートを行います
      </div>
    </div>
    <div class="setting-wrap">
      <div class="wrap-title">新規登録リクエスト・データインポート</div>
      <div class="new-request-import-wrap">
        <el-tooltip placement="top" :disabled="create_request_enabled">
            <div class="activate-popover" slot="content">
              <div class="pointer" @click="toSetting">アップグレード</div>
              でご利用いただけます
            </div>
            <div class="new-request" @click="create_request_enabled ? openRequestDrawer() : false" :class="request_drawer ? 'focus' : ''">
              <img src="../../assets/request.png" class="new-request-img" alt="" />
              <span class="new-request-title">登録リクエスト</span>
              <span>{{ siteName }} に未登録のインフルエンサーの新規登録をリクエストします。</span>
            </div>
        </el-tooltip>
        <div class="new-request right" @click="openImportDrawer()" :class="import_drawer ? 'focus' : ''">
          <img src="../../assets/import.png" class="new-request-img" alt="" />
          <div class="new-request-title">
            データインポート
          </div>
          <span>貴社のインフルエンサーデータ(住所・電話番号・コメント)などをインポートし、{{ siteName }} に登録されているインフルエンサーデータと統合します。</span>
        </div>
      </div>
    </div>
    <requestDrawer :request_drawer.sync="request_drawer" :influencer_bulk.sync="influencer_bulk" :sns_type.sync="sns_type" />
    <importDrawer :import_drawer.sync="import_drawer" @openRequestDrawer="openRequestDrawer"/>
  </div>
</template>

<script>
import requestDrawer from "./request_drawer";
import importDrawer from "./import_drawer";
import UserTokenSiteInfo from "@/components/oem/UserTokenSiteInfo.vue";

export default {
  name: "requestTop",
  components: {
    requestDrawer,
    importDrawer,
    UserTokenSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      request_drawer: false,
      import_drawer: false,
      influencer_bulk: "",
      sns_type: "instagram",
      siteName: 'REECH DATABASE',
    };
  },
  computed: {
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
    activate() {
      return this.$store.state.activate;
    },
    create_request_enabled() {
      return this.$store.state.service_plan.create_request_enabled ? true : false;
    },
  },
  mounted() {},
  methods: {
    openRequestDrawer(influencer_bulk, sns_type) {
      if (this.permission.request.access) {
        this.request_drawer = true;
        this.sns_type = sns_type;
        if (influencer_bulk) this.influencer_bulk = influencer_bulk;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    openImportDrawer() {
      if (this.permission.import.access) {
        this.import_drawer = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    toSetting() {
      this.$router.push("/setting");
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
  watch: {},
};
</script>

<style></style>
